<template>
  <div class="gatekeeper-survey">
    <h2>{{ $t("gatekeeper.title") }}</h2>
    <p>
      {{ $t("gatekeeper.instruction1") }}
      <router-link to="guidelines">{{
        $t("gatekeeper.instruction2")
      }}</router-link>
      {{ $t("gatekeeper.instruction3") }}
    </p>
    <p>
      <em>{{ $t("gatekeeper.intro") }}</em>
    </p>
    <div class="questions" v-if="eligible === 'process'">
      <!-- <form> -->
      <div
        class="question"
        :key="question.number"
        :id="'q-' + question.number"
        v-for="question in GateKeeperQuestions.questions"
      >
        <p class="questionText">{{ question.question[$i18n.locale] }}</p>
        <div v-if="question.type === 'buttons'" class="question-input">
          <f-button
            @click="handleAnswer(question, item, key)"
            v-for="(item, key) in question.answers[$i18n.locale]"
            :value="key"
            :key="key"
            :type="getType(question, key)"
            >{{ key }}</f-button
          >
        </div>
        <div v-else class="input-question question-input">
          <f-input
            @input="handleInput"
            :type="question.type"
            :title="question.placeholder[$i18n.locale]"
            :data="question"
          />
          <f-button @click="nextQuestion(question)" :type="'round'"></f-button>
        </div>
      </div>
      <!-- </form> -->
    </div>
    <div class="questions eligible" v-else-if="eligible === true">
      <p>
        <strong>{{ $t("gatekeeper.thanks") }}</strong>
      </p>
      <p>{{ $t("gatekeeper.success") }}</p>
      <f-button @click="navigate('donation-form')">{{
        $t("gatekeeper.continue")
      }}</f-button>
    </div>
    <div class="questions not-eligible" v-else-if="eligible === false">
      <p>{{ $t("gatekeeper.thanks") }}</p>
      <p>{{ $t("gatekeeper.failed") }}</p>
      <f-button @click="navigate('guidelines')">{{
        $t("gatekeeper.guidelines")
      }}</f-button>
    </div>
  </div>
</template>

<!-- Script
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
<script>
import { setTimeout } from "timers";
export default {
  name: "gatekeeperSurvey",
  components: {},
  data() {
    return {
      eligible: "process",
      windowWitdh: this.windowWidth,
      // type: this.getType(key)
    };
  },

  /* ------------------------------ */
  /* LIFECYCLE HOOKS */
  mounted: function () {
    this.setSizesQuestionContainer();
    this.$store.commit("RESET");
    window.addEventListener("resize", this.handleWindowResize);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.handleWindowResize);
  },

  /* ------------------------------ */
  /* METHODS */
  methods: {
    getType: function (question, item) {
      let numberOfAnswers = Object.keys(question.answers.nl).length;
      if (numberOfAnswers >= 5) {
        if (item.toLowerCase() == "nee" || item.toLowerCase() == "no")
          return "outline";
      }
      return;
    },
    handleAnswer: function (question, answer, key) {
      question.response = answer;
      if (question.id === "categorie") {
        question.response = key;
      }
      let nextStep = question.next[answer];
      if (nextStep === false) {
        this.eligible = false;
      } else if (nextStep === true) {
        this.eligible = true;
        this.$store.commit("ADD_QUESTION", question);
      } else {
        if (question.number === 6 && answer === false) {
          var isAnswered =
            this.GateKeeperQuestions.questions[4].hasOwnProperty("response");
          if (!isAnswered) {
            this.GateKeeperQuestions.questions[4].next = 8;
            nextStep = 5;
          }
        }
        this.$store.commit("ADD_QUESTION", question);
        this.setQuestion(question.number, nextStep);
      }
    },
    handleInput: function (question, answer) {
      question.response = answer;
    },
    nextQuestion: function (question) {
      this.$store.commit("ADD_QUESTION", question);
      this.setQuestion(question.number, question.next);
    },
    setQuestion: function (actual, next) {
      if (typeof next === "number") {
        document.getElementById("q-" + actual).classList.add("fade-out");
        document.getElementById("q-" + next).classList.add("fade-in");
      }
    },
    setSizesQuestionContainer: function () {
      let questionContainer = document.querySelectorAll(".questions")[0];
      let questions = questionContainer.querySelectorAll(".question");
      let highestHeight = 0;
      let width = questionContainer.clientWidth;
      width = questionContainer.offsetWidth;

      for (let i = 0; i < questions.length; i++) {
        questions[i].style.width = 0;
        /* set width first so we can calculate correct height */
        // questions[i].style.width = `${width}px`
        questions[i].style.width = width + "px";

        /* get height of highest question */
        let questionHeight = questions[i].clientHeight;
        if (questionHeight > highestHeight) highestHeight = questionHeight;
      }

      /* set height of container */
      questionContainer.style.height = `${highestHeight}px`;

      /* set height of all questions for vertical alignment */
      for (let i = 0; i < questions.length; i++) {
        questions[i].style.height = `${highestHeight}px`;
      }
    },
    handleWindowResize(event) {
      this.windowWidth = event.currentTarget.innerWidth;
      this.setSizesQuestionContainer();
    },
  },
};
</script>

<!-- Style
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ -->
<style lang="scss" scoped>
.gatekeeper-survey {
  padding-top: 60px;
  padding-bottom: 40px;
  background-color: $light-grey;
  text-align: center;
  // @include card-shadow();

  @include min-large {
    padding-top: 80px;
    padding-bottom: 60px;
  }

  h2,
  > p {
    padding-left: $padding-mobile;
    padding-right: $padding-mobile;
  }

  > p {
    margin-top: 6px;
    font-size: 80%;
    font-weight: light;
  }

  a {
    color: $dark-green;
    font-weight: bold;
  }

  .questions {
    position: relative;
    @include maxWidthCenter();
    max-width: 600px;
    margin-top: 40px;
    @include card-shadow();
    background-color: white;
    overflow: hidden;

    @include min-large {
      border-radius: $border-radius;
    }

    .question {
      position: absolute;
      left: 100%;
      @include flex(space-around, inherit);
      flex-direction: column;
      min-height: 160px;
      padding: 1em 2em;
      opacity: 0;
      transition: all 0.5s cubic-bezier(0.51, 0.14, 0.69, 1.12);

      &:first-of-type {
        @include flex(space-around, inherit);
        left: 0;
        opacity: 1;
      }

      &.fade-in {
        left: 0;
        opacity: 1;
      }

      &.fade-out {
        left: -100%;
        opacity: 0;
      }

      /* The question text */
      .questionText {
        margin-bottom: 0.75em;
      }

      /* The answer options - so buttons or input */
      .question-input {
        button {
          margin-bottom: 8px;
        }

        button:nth-of-type(odd):not(.outline):not(.round) {
          float: left;
          @include small-button {
            float: none;
            display: block;
            width: 100%;
          }
        }
        button:nth-of-type(even) {
          float: right;
          @include small-button {
            float: none;
            display: block;
            width: 100%;
          }
        }

        .outline {
          min-width: 200px;
        }
      }

      /* When the anwer options are buttons */
      button {
        // margin-right: .5em;
        text-transform: capitalize;
      }

      /* When the answer options are an input */
      .input-question {
        position: relative;

        .form-group {
          width: calc(100% - 50px);
          margin-right: 50px;
        }
        button {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 0;
        }
      }
    }
    &.eligible,
    &.not-eligible {
      padding: 1em 2em;

      p:first-of-type {
        font-weight: 600;
      }
      p:last-of-type {
        margin-top: 20px;
        margin-bottom: 20px;
        font-size: 0.9em;
      }
      button {
        width: 100%;
      }
    }
  }
}
</style>
